/**
 * @desc 查询石灰石需求月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthLimestoneResponse>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanLimestone',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthLimestoneResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanLimestone',
    data,
  });
}
